<template>
  <div class="row">
    <div class="col-12 mb-3">
      <button class="btn btn-primary" @click="$router.push({name: 'edit_version' , params: {id: 'new'}})">
        افزودن
        <i class="fas fa-plus"/>
      </button>
      <hr>
    </div>
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو نسخه
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="search">
              <label for="order" class="text-right mb-1">ترتیب</label>
              <input id="order" v-model.number="filters.order" type="text" class="fv-sm form-control"
                     placeholder="ترتیب">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="search">
              <label for="sort" class="text-right mb-1">نمایش براساس</label>
              <fv-select id="sort" class="fv-form-control" v-model="sort"
                         :options="[{text: 'جدیدترین',value:'-_score,-version_no_str'},{text: 'قدیمی ترین',value:'-_score,-version_no_str'}]"/>
            </div>
          </div>

          <div class="col-12 text-left">
            <button @click.prevent="search" class="btn btn-info">
              جستجو
              <i class="fas fa-search"/>
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="item.length > 0" :fields="fields" :rows="item">
        <template slot="field-#" slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>
        <template slot="field-ورژن" slot-scope="scope">
          {{scope.row.version_no_str|| '---'}}
        </template>

        <template slot="field-زمان" slot-scope="scope">
          {{$dateTimeFormat(scope.row.created_at) || '---'}}
        </template>

        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({name: 'edit_version' , params : {id: scope.row.id} })"
                  class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit"/>
          </button>
        </template>
      </fvTable>
    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(item).length > 0 && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>

  </div>
</template>
<script>

  import {mapActions} from "vuex"
  import appPagination from "../../../components/appPagination";

  export default {
    name: 'versions',
    components: {
      appPagination
    },
    data() {
      const {query} = this.$route
      const {page, filters, sort} = query;
      const filtersObj = filters ? JSON.parse(filters) : {}
      return {
        ...mapActions('main', [
          'crud'
        ]),
        item: [],
        fields: ['#', 'ورژن', 'زمان', 'actions'],
        query,
        filters: filtersObj,
        sort: sort || '-_score,-version_no_str',
        page : parseInt(page) || 1,
        pagination: {}
      }
    },
    methods: {
      async getData() {
        this.$store.commit('main/SET', {key: 'loading', value: true})
        try {
          const apiFilters = await this.$generateFilter(this.filters)
          const item = await this.crud({
            action: 'get',
            section: 'versions',
            query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`
          })

          if (item.data && item.data.items) {
            const result = item.data.items
            this.item = result
            this.pagination = item.data.pagination
          }
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
      async search() {
        this.filters = await this.$validateFilter(this.filters)
        await this.$router.push({
          query: {
            filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
            sort: this.sort || undefined,
            page: this.page
          }
        })
      }
    },

    async created() {
      await this.getData()
    },
    watch: {
      '$route.query'() {
        this.getData();
      }
    },
  };
</script>
<style>
</style>
